import React from "react";

import Card, { CardProps } from "@mui/material/Card";

function MapCard(props: CardProps) {
  return <Card {...props} />;
}

export default MapCard;
